import React from "react";
import ReactDOM from "react-dom/client";

// Self-hosted Inter (was a Google Fonts <link> in index.html — an external
// render-blocking stylesheet that hung the whole page when the CDN was
// unreachable, and a needless external dependency in prod).
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import { App } from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
